import { ApiKeyCreator } from "~/modules/api_keys/components/ApiKeyCreator";
import { ApiKeyListFetcher } from "~/modules/api_keys/components/ApiKeyListFetcher";
import { User } from "~/modules/user/store/types";
import { ApiKeyForm } from "~/modules/api_keys/components/ApiKeyForm";
import {
    ApiKeyUpdater,
    UpdateApiKeyParams,
} from "~/modules/api_keys/components/ApiKeyUpdater";
import { ApiKeyList } from "./ApiKeysList";
import { ApiKeySecurityNotice } from "../../components/ApiKeySecurityNotice";

// // // //

export function ApiKeysPageLayout(props: { user: User }) {
    const { user } = props;

    return (
        <ApiKeyCreator user={user}>
            {({ createApiKey, loading: creating }) => (
                <ApiKeyUpdater user={user}>
                    {({ loading: updating, updateApiKey }) => (
                        <ApiKeyListFetcher user={user}>
                            {({
                                loading: fetching,
                                apiKeys,
                                refetchApiKeys,
                            }) => (
                                <div className="space-y-6 mt-6">
                                    <ApiKeyForm
                                        loading={creating}
                                        apiKeyInput={{
                                            name: "",
                                            archived: false,
                                        }}
                                        onSubmit={(apiKeyInput) => {
                                            createApiKey(apiKeyInput).then(
                                                () => {
                                                    refetchApiKeys();
                                                },
                                            );
                                        }}
                                    />

                                    <ApiKeySecurityNotice />

                                    <ApiKeyList
                                        apiKeys={apiKeys}
                                        loading={fetching || updating}
                                        onUpdateApiKey={(
                                            apiKeyToUpdate: UpdateApiKeyParams,
                                        ) => {
                                            return new Promise((resolve) => {
                                                return updateApiKey({
                                                    id: apiKeyToUpdate.id,
                                                    name: apiKeyToUpdate.name,
                                                    archived:
                                                        apiKeyToUpdate.archived,
                                                })
                                                    .then((resp) => {
                                                        refetchApiKeys();
                                                        resolve(resp);
                                                    })
                                                    .catch(() => {
                                                        console.log("CATCH!");
                                                        refetchApiKeys();
                                                    });
                                            });
                                        }}
                                    />
                                </div>
                            )}
                        </ApiKeyListFetcher>
                    )}
                </ApiKeyUpdater>
            )}
        </ApiKeyCreator>
    );
}
